<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width  h-full'>
         <div class="banner_gruop">
            <div class="banner_title"> <span class="color3"></span> Mission & Vision</div>
            <div class="banner_tips mt-40 fw-300">We're building the financial infrastructure for the modern web. Our mission: replace legacy systems, eliminate delays and intermediaries, and remove manual errors. We envision instant, low-cost cross-border payments with full user control over financial data. </div>     
          </div>
          <!-- <div class="call_grid border-focus">
            <div class="call_item px-20 py-40">
              <div class="color8 fs-f40">Global Reach</div>
              <div class="color1 mt-10 fw-400 fs-f16">Seamless transactions anywhere, anytime.</div>
            </div>
            <div class="call_item px-20 py-40">
              <div class="color8 fs-f40">Empowered Users</div>
              <div class="color1 mt-10 fw-400 fs-f16">Your data, your control, no gatekeepers.</div>
            </div>
            <div class="call_item px-20 py-40">
              <div class="color8 fs-f40">Frictionless Finance</div>
              <div class="color1 mt-10 fw-400 fs-f16">Fast, transparent, and cost-effective solutions.</div>
            </div>
          </div>
         <div class="page_title mt-100">
            <div class="title_name color1">Driving Financial Transformation</div>
            <div class="title_tag color1">We’re revolutionizing finance through open banking. Our goal is to create a system where payments are instant, borders are irrelevant, and financial insights are accessible to all—not just banks.</div>
          </div> -->
       </div>
    </div>
    <div class="container bg_2 pt-80"> 
      <div class="" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Why Corelinkpay?</div>
            <div class="title_tag color1">Features built for e-commerce</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p card_bg">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb37.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Innovation</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Pushing the boundaries of what's possible in fintech.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p card_bg">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb38.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Transparency</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Open, honest, and clear processes that build trust.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p card_bg" >
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb39.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Inclusivity</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Solutions that empower everyone, everywhere.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container pb-80"> 
      <div class="page_top" >
        <div class="page_width" > 
         
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_col_start" >
                  <div class="page_title pb-30">
                      <div class="title_name color1 text-l">What We Offer</div>
                      <div class="title_tag color1 text-l">Payment infrastructure for online and in-person transactions. Instant payouts, smart routing, and seamless omnichannel experiences built to simplify every transaction.</div>
                  </div>
                    <div class="tab_group text-l mt-10" :class="[show1?'active_item':'']">
                        <!-- <div class="h-10px mb-20 bg_3 title_line"></div> -->
                        <div class="half_title fs-22 pointer" @click="showOne(1)">Online & In-Store</div>
                        <el-collapse-transition>
                          <div class="half_text color1 fs-14 fw-300" v-show="show1">Unified payment experiences across all channels.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-10" :class="[show2?'active_item':'']">
                        <!-- <div class="h-10px mb-20 bg_3 title_line"></div> -->
                        <div class="half_title fs-22 pointer" @click="showOne(2)">Fast & Secure</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show2">Cutting-edge tech for reliable, protected transactions.</div>
                        </el-collapse-transition>
                       
                    </div>
                    <div class="tab_group text-l mt-10" :class="[show3?'active_item':'']">
                        <!-- <div class="h-10px mb-20 bg_3 title_line"></div> -->
                        <div class="half_title fs-22  pointer" @click="showOne(3)">Global Flexibility</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show3">100+ currencies. 55+ countries.</div>
                        </el-collapse-transition>
                       
                    </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t56.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="page_title_bg pt-60 pb-60" >
        <div class="page_width " >
           <div class="page_title">
            <div class="title_name color1">Transforming Finance</div>
            <div class="title_tag color1">We're rebuilding finance through open banking. Instant payments, borderless transactions, and financial insights accessible to everyone—not just banks.</div>
          </div>
          <div class="grid mt-60">
            <div class="grid_md_4 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz9.png" alt="" class="h-140px w-a">
                <div class="fs-30 mt-20 color1 fw-300">Transactions anywhere, anytime.</div>
              </div>
            </div>
            <div class="grid_md_4 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz10.png" alt=""  class="h-140px w-a">
                <div class="fs-30 mt-20 color1 fw-300">Your data, your control.No gatekeepers.</div>
              </div>
            </div>
            <div class="grid_md_4 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz11.png" alt=""  class="h-140px w-a"> 
                <div class="fs-30 mt-20 color1 fw-300">Fast, transparent,cost-effective.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>

  
    
    

  
  </div>
</template>

<script>


export default {
    data(){
        return{
          show1:true,
          show2:false,
          show3:false,
        }
    },
    methods:{
      showOne(tab){
        if(this.show1 && tab == 1 || this.show2 && tab == 2 || this.show3 && tab == 3){
          this.show1 = false
          this.show2 = false
          this.show3 = false
          return
        }
        switch (tab) {
          case 1:
            this.show1 = true
            this.show2 = false
            this.show3 = false
            break;
          case 2:
            this.show1 = false
            this.show2 = true
            this.show3 = false
            break;
          case 3:
            this.show1 = false
            this.show2 = false
            this.show3 = true
            break;
          default:
            break;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg10.png);
    background-size: 100% 100%;
    background-position: center center;
}

.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.call_grid{
  background:rgba(255, 255, 255,0.3);
  position: relative;
  &::before{
    content:'';
    width: 2px;
    height: calc(100% - 80px);
    background:#fff;
    top:40px;
    left:33.33%;
    position: absolute;
  }
   &::after{
    content:'';
    width: 2px;
    height: calc(100% - 80px);
    background:#fff;
    top:40px;
    right:33.33%;
    position: absolute;
  }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.h-full{
  height: 600px;
}
.tab_group{
  padding-left:20px;
 
  .half_title{
    color:$theme_color1;
     position: relative;
      &::before{
        content: "";
        position: absolute;
        left: -20px;
        top: 18px;
        width: 8px;
        height: 8px;
        border-left: 3px solid #dddddd;
        border-top: 3px solid #dddddd;
        transition: all 0.35s ease-in-out;
        transform: rotate(135deg);
      }
  }
 
}
.active_item{
  .half_title{
      color: $theme_color3;
      &::before{
        border-left: 3px solid $theme_color3;
        border-top: 3px solid $theme_color3;

        transform: rotate(225deg);
      }
  }
   

}
@media screen and (max-width:767px){
  .h-full{
    height: 600px;
  }
  .page_title{
    margin-top:50px;
  }
  .call_grid{
    >div{
      padding:20px;
    }
  }
}
</style>